import mediaUploader from "../mediaUploader/mediaUploader.vue";

import {
  NEWS_CATEGORY_SPECIAL_OFFERS,
  NEWS_CATEGORY_NEW_HOTEL,
  NEWS_CATEGORY_DEVELOPMENT,
  FILE_TYPE_NEWS_GALLERY,
  FILE_TYPE_NEWS_ATTACHMENT
} from "../../../util/enumTypes";

import { NEWS_NEW, NEWS_EDIT } from "../../../util/enumTypes";

import _map from "lodash/map";
import _isEmpty from "lodash/isEmpty";
import util from "../../../util/util";

export default {
  components: {
    croopie: () =>
      import(/* webpackChunkName: "croopie" */ "../croopie/croopie.vue"),
    mediaUploader,
    tinymce: () =>
      import(
        /* webpackChunkName: "tinymce" */ "vue-tinymce-editor/src/components/TinymceVue.vue"
      )
  },
  props: {
    news: {},
    status: {
      default: NEWS_NEW
    },
    lang: {
      default: "en"
    },
    tinymceLoaded: {
      default: false
    },
    processLoading: {
      default: false
    },
    previewGalleries: {
      default: () => []
    },
    previewAttachments: {
      default: () => []
    }
  },
  data() {
    return {
      newsForPublish: {
        title: "",
        category: "",
        previewPhoto: "",
        previewText: "",
        text: "",
        galaries: [],
        attachments: []
      },
      errors: {
        title: false,
        previewText: false,
        category: false,
        text: false
      },
      acceptTypes: [".png", ".jpeg", ".jpg"],
      img: null,
      routePreview: "",
      specialOffersCategory: NEWS_CATEGORY_SPECIAL_OFFERS,
      newHotelCategory: NEWS_CATEGORY_NEW_HOTEL,
      developmentCategory: NEWS_CATEGORY_DEVELOPMENT,
      galleryType: FILE_TYPE_NEWS_GALLERY,
      attachmentType: FILE_TYPE_NEWS_ATTACHMENT,
      galleryUploader: "galleryUploader",
      attachmentUploader: "attachmentUploader",
      hotelId: null
    };
  },
  computed: {
    hotelList() {
      let result = [];

      let citiesAndHotels = this.$store.state.InitDataStorage.citiesAndHotels;

      if (citiesAndHotels.length) {
        citiesAndHotels.forEach(c => {
          c.hotels.forEach(h => {
            result.push({
              value: h.id,
              label: `${h.name}, ${c.name}`
            });
          });
        });

        result.sort((a, b) => (a.label < b.label ? -1 : 1));
      }

      return result;
    }
  },
  methods: {
    announcementClick() {
      document.getElementById("announcement").click();
    },
    changeAnnouncementImage(fakepath) {
      if (
        document.getElementById("announcement").files[0].size / 1024 / 1024 >
        5
      ) {
        return;
      } else if (!this.hasExtension()) {
        return;
      } else {
        this.img = document.getElementById("announcement").files[0];
        this.$refs.croppieRef.bind({
          url: fakepath
        });
        document.getElementById("announcement").value = null;
      }
    },
    hasExtension() {
      let fileName = document.getElementById("announcement").files[0].name;
      return new RegExp(
        "(" + this.acceptTypes.join("|").replace(/\./g, "\\.") + ")$"
      ).test(fileName);
    },
    croppieResult(blob) {
      var fullPath = document.querySelector('.picture-input input[type="file"]')
        .value;
      if (fullPath) {
        var startIndex =
          fullPath.indexOf("\\") >= 0
            ? fullPath.lastIndexOf("\\")
            : fullPath.lastIndexOf("/");
        var filename = fullPath.substring(startIndex);
        if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
          filename = filename.substring(1);
        }
        blob.name = filename;
      }
      this.$emit("croppieResult", blob);
    },
    update(e) {
      console.log("Update", e);
    },

    remove() {
      this.$emit("croppieResultRemove");
    },

    // renamed, becouse cropper also has remove() method
    deleteNews() {
      this.$emit("deleteNews", this.newsForPublish.newsId);
    },
    preview() {
      console.log("preview");
    },
    showSaveError() {
      this.$message({
        type: "error",
        message: this.$t("news_miss_required_fields"),
        duration: 5000
      });
    },
    async sendNews() {
      if (!this.isValid(true)) {
        util.scrollMeTo("formNews", 0);
        this.showSaveError();
        return;
      }
      await this.updateFilesDescriptions();
      this.$emit("submit", { news: this.newsForPublish });
    },

    async updateFilesDescriptions() {
      let galleryUploadPromise = new Promise(async (resolve, reject) => {
        await this.$refs[this.galleryUploader].setChangedDescriptions();
        resolve();
      });

      let attachmentsUploadPromise = new Promise(async (resolve, reject) => {
        await this.$refs[this.attachmentUploader].setChangedDescriptions();
        resolve();
      });

      await Promise.all([galleryUploadPromise, attachmentsUploadPromise]);
    },

    showPreview(e) {
      let index = this.routePreview == this.$t("news_single") ? 0 : 1;
      this.$emit("showPreview", { index, news: this.newsForPublish });
      this.routePreview = null;
    },
    isValid(bool) {
      if (!this.newsForPublish.title) {
        if (bool) {
          this.errors.title = true;
          this.cancelError("title");
        }
        return false;
      }
      if (!this.newsForPublish.previewText) {
        if (bool) {
          this.errors.previewText = true;
          this.cancelError("previewText");
        }
        return false;
      }
      if (!this.newsForPublish.category) {
        if (bool) {
          this.errors.category = true;
          this.cancelError("category");
        }
        return false;
      }
      if (!this.newsForPublish.text) {
        if (bool) {
          this.errors.text = true;
          this.cancelError("text");
        }
      } else {
        return true;
      }
    },
    cancelError(field) {
      setTimeout(() => {
        this.errors[field] = false;
      }, 5000);
    },
    setNews() {
      this.newsForPublish = Object.assign({}, this.news);
      this.newsForPublish.attachments = _map(
        this.newsForPublish.attachments,
        "url"
      );
      this.newsForPublish.galaries = _map(this.newsForPublish.galaries, "url");
      this.status = NEWS_EDIT;
    },
    copyHotelLink() {
      let city = this.$store.state.InitDataStorage.initData.getCityByHotelId(
        this.hotelId
      );
      if (!city) {
        return false;
      }

      navigator.clipboard
        .writeText(`/?cityId=${city.id}&hotelId=${this.hotelId}`)
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$t("news_generate_hotel_copy_buffer"),
            type: "success"
          });
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: this.$t("news_generate_hotel_copy_buffer_err"),
            type: "error"
          });
        });
    }
  },
  mounted() {
    if (!_isEmpty(this.news)) {
      this.setNews();
    }
  },
  watch: {
    lang(val, old) {
      console.log(val, old);
    },
    news() {
      if (!_isEmpty(this.news)) this.setNews();
    }
  }
};
